/** State spelling and persisted identity use the same equivalence relation. */
export const stateIdentityName = (name: string): string =>
  name.normalize("NFC").replace(/\s+/g, " ").trim().toLowerCase();
